/**
 *
 *  Development utilities
 *
 *
 *
 */

import {
  devPriceCacheClear,
  getPriceLinesByCache
} from "./app-patient/price-cache";

declare global {
  interface Window {
    getPriceLinesByCache: typeof getPriceLinesByCache;
    devPriceCacheClear: typeof devPriceCacheClear;
  }
}

if (typeof window !== "undefined") {
  window.getPriceLinesByCache = getPriceLinesByCache;
  window.devPriceCacheClear = devPriceCacheClear;
}
